import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ChipComponent } from '../chip/chip';

// One address box: the lines on the left, a chip naming the address on the right.
@Component({
  selector: 'lib-address',
  templateUrl: './address.html',
  styleUrl: './address.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ChipComponent],
})
export class AddressComponent {
  lines = input.required<string[]>();
  chipText = input.required<string>();
  chipType = input<'primary' | 'secondary'>('primary');
}
